import React, { useEffect, useState } from "react"

import {
  Col,
  Row,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Progress,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap"

import { connect } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"

// Import images
import SubstrateImg from "../../assets/images/SubstrateImg.png"
import InoculationImg from "../../assets/images/inoculation.png"
import FruitingImg from "../../assets/images/fruiting1.png"
import HarvestingImg from "../../assets/images/harvesti.png"

import QR from "../../assets/images/qr.png"
import axios from "axios"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BagDetails = props => {
  document.title = "Bag Details | My Urban Farms"

  const breadcrumbItems = [
    { title: "Batche-Details", link: "/batch-details" },
    { title: "Bag Details", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems("Bag Details", breadcrumbItems)

  }, [])

  const [sequenceList, setSequenceList] = useState([]);
  const [processHistory, setProcessHistory] = useState([]);
  const location = useLocation();

  // Read from state (frontend redirect)
  const batchKeyState = location.state?.batchKey || null;
  const bagKeyState = location.state?.bagKey || null;
  const bagManageKeyState = location.state?.pk_bag_manage_key || null;
  const selectedFarmKeyState = location.state?.selectedFarmKey || null;


  // Read from URL (QR redirect)
  const query = new URLSearchParams(location.search);
  const batchKeyQuery = query.get("batch_key");
  const bagKeyQuery = query.get("bag_key");
  const bagManageKeyQuery = query.get("bag_manage_key");
  const selectedFarmKeyQuery = query.get("farm_key");

  

  // Final fallback logic
  const batchKey = batchKeyState || batchKeyQuery;
  const bagKey = bagKeyState || bagKeyQuery;
  const selectedFarmKey = selectedFarmKeyState || selectedFarmKeyQuery;

  const pk_bag_manage_key = bagManageKeyState || bagManageKeyQuery;

  // stateful manage key so we can update it when server returns a new one
  const [pkBagManageKey, setPkBagManageKey] = useState(bagManageKeyState || bagManageKeyQuery || null);




  // const bagKey = location.state?.bagKey;
  // const pk_bag_manage_key = location.state?.pk_bag_manage_key;

  const fetchSavedSequence = async () => {
    try {
      const URL = `${process.env.REACT_APP_API_BASE_URL}/getProcessSequence/process/`;
      const res = await axios.post(URL, { farmKey: selectedFarmKey });
      const seq = res.data?.message?.data?.data || [];

      if (Array.isArray(seq)) {
        setSequenceList(seq);
      }
    } catch (err) {
      console.error("Failed to fetch sequence:", err);
    }
  };

  const [harvestModalOpen, setHarvestModalOpen] = useState(false);
  const [harvestDate, setHarvestDate] = useState("");
  const [harvestCount, setHarvestCount] = useState("");
  const [selectedHarvestBag, setSelectedHarvestBag] = useState(null);

  const openHarvestModal = (bag) => {
    setSelectedHarvestBag({
      batchKey: bag.fk_batch_key,
      pkBagManageKey: bag.pkBagManageKey,
      batchManageKey: bag.bagKey,
      id: bag.id,
    });

    setHarvestDate("");
    setHarvestCount("");
    setHarvestModalOpen(true);
  };

  // const handleSaveHarvest = async () => {
  //   if (!harvestDate || !harvestCount) {
  //     toast.error("Please fill all fields");
  //     return;
  //   }

  //   const payload = {
  //     harvest_date: harvestDate,
  //     harvest_count: harvestCount,
  //     fk_batch_key: selectedHarvestBag.batchKey,
  //     fk_bag_key: selectedHarvestBag.batchManageKey,
  //     pk_bag_manage_key: selectedHarvestBag.pkBagManageKey,
  //     bag_num: selectedHarvestBag.id,
  //     status: '1',
  //     created_by: adminKey
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_BASE_URL}/harvestcount/harvest/`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     const data = await response.json();

  //     if (data?.message?.success === true) {
  //       toast.success(data.message.message || "Harvest count saved!");
  //       loadBagDetails();
  //       loadBagHistoryDetails();
  //       setHarvestModalOpen(false);
  //     } else {
  //       toast.error(data?.message?.message || "Failed to save");
  //     }

  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Server error");
  //   }
  // };


  const handleSaveHarvest = async () => {
    if (!harvestDate || !harvestCount) {
      toast.error("Please fill all fields");
      return;
    }

    const checkPayload = {
      fk_batch_key: selectedHarvestBag.batchKey,
      fk_bag_key: selectedHarvestBag.batchManageKey,
      pk_bag_manage_key: selectedHarvestBag.pkBagManageKey,
      harvest_date: harvestDate,
      fk_farm_key: selectedFarmKey
    };

    const checkRes = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/checkDuplicateHarvest/harvest/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(checkPayload),
      }
    );

    const checkData = await checkRes.json();


    const duplicate = checkData?.message?.data;

    if (duplicate?.exists === true) {
      toast.error(duplicate.message || "Duplicate harvest entry!");
      return;
    }

    const payload = {
      harvest_date: harvestDate,
      harvest_count: harvestCount,
      fk_batch_key: selectedHarvestBag.batchKey,
      fk_bag_key: selectedHarvestBag.batchManageKey,
      pk_bag_manage_key: selectedHarvestBag.pkBagManageKey,
      bag_num: selectedHarvestBag.id,
      status: "1",
      created_by: adminKey,
      fk_farm_key: selectedFarmKey,
    };

    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/harvestcount/harvest/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data?.message?.success === true) {
      toast.success(data.message.message || "Harvest added successfully");
      setHarvestModalOpen(false);
      loadBagDetails();
      loadBagHistoryDetails();
    } else {
      toast.error(data?.message?.message || "Failed to save");
    }
  };


  const [bags, setBags] = useState([]);
  const [processList, setProcessList] = useState([]);

  const fetchProcesses = async () => {
    try {
      const processRes = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllProcess/process/`, { farmKey: selectedFarmKey }
      );
      const processList = processRes.data?.message?.data || [];

      const seqRes = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getProcessSequence/process/`, { farmKey: selectedFarmKey }
      );
      const sequenceList = seqRes.data?.message?.data?.data || [];

      const merged = processList.map(proc => {
        const seq = sequenceList.find(s => s.fk_process_key === proc.pk_process_key);

        return {
          ...proc,
          process_position: seq ? seq.process_position : null
        };
      });

      setProcessList(merged);
    } catch (err) {
      console.error("Failed to load processes", err);
    }
  };


  // function parseDuration(durationText) {
  //   if (!durationText) return { days: 1, hours: 0 };

  //   durationText = durationText.toLowerCase().replace(/\s+/g, "");

  //   const numbers = durationText.match(/\d+/g)?.map(Number) || [];

  //   const maxValue = Math.max(...numbers);

  //   if (durationText.includes("hour")) {
  //     return { days: 0, hours: maxValue };
  //   }

  //   return { days: maxValue, hours: 0 };
  // }

  // function calculateProgress(processDate, processDuration) {
  //   const { days, hours } = parseDuration(processDuration);

  //   const start = new Date(processDate);
  //   const now = new Date();

  //   const diffMs = now - start;
  //   const diffDays = diffMs / (1000 * 60 * 60 * 24);
  //   const diffHours = diffMs / (1000 * 60 * 60);

  //   let progress = 0;

  //   if (days > 0) {
  //     progress = (diffDays / days) * 100;
  //   } else if (hours > 0) {
  //     progress = (diffHours / hours) * 100;
  //   }

  //   return Math.min(100, Math.floor(progress));
  // }

  function parseDuration(duration) {
    if (!duration) return { days: 0, hours: 0 };

    const lower = duration.toLowerCase();

    // Example formats: "10 days", "12 hrs", "5 day", "1 hr"
    const dayMatch = lower.match(/(\d+)\s*day/);
    const hourMatch = lower.match(/(\d+)\s*hr/);

    return {
      days: dayMatch ? parseInt(dayMatch[1]) : 0,
      hours: hourMatch ? parseInt(hourMatch[1]) : 0,
    };
  }

  function calculateProgress(processDate, processDuration) {
    if (!processDate || !processDuration) return 0;

    const { days, hours } = parseDuration(processDuration);

    const start = new Date(processDate);
    const now = new Date();

    const diffMs = now - start;

    const totalMs =
      (days * 24 * 60 * 60 * 1000) +
      (hours * 60 * 60 * 1000);

    if (totalMs <= 0) return 0;

    let progress = (diffMs / totalMs) * 100;

    if (progress < 0) progress = 0;
    if (progress > 100) progress = 100;

    return Math.floor(progress);
  }

  function calculateDueDate(startDate, durationText) {
    if (!startDate || !durationText) return "-";

    const { days, hours } = parseDuration(durationText);
    const start = new Date(startDate);

    // Add days
    if (days > 0) start.setDate(start.getDate() + days);

    // Add hours
    if (hours > 0) start.setHours(start.getHours() + hours);

    return start.toISOString().slice(0, 10);
  }


  useEffect(() => {
    if (!batchKey) {
      console.error("Batch key missing");
      return;
    }

    fetch(`${process.env.REACT_APP_API_BASE_URL}/getBagDetails/batch`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fk_batch_key: batchKey, fk_bag_key: bagKey }),
    })
      .then(res => res.json())
      .then(data => {
        console.log("API RESP", data);

        if (data.success === 1 && Array.isArray(data.bags?.data)) {
          const formatted = data.bags.data.map(b => {
            const progress = calculateProgress(b.process_created_on, b.process_duration);
            const dueDate = calculateDueDate(b.process_date, b.process_duration);

            return {
              id: b.bag_num,
              fk_batch_key: b.fk_batch_key,
              bagKey: b.bag_key,
              batchId: b.batch_num,
              processKey: b.fk_process_key,
              processSeqKey: b.fk_process_seq_key,
              currentStage: b.current_stage,
              startDateDate: b.process_date,
              startDate: b.process_created_on,
              processDuration: b.process_duration,
              dueDate: dueDate,
              progress,
              status: "In-Progress",
              qr_image: b.qr_image,
              processImage: `${process.env.REACT_APP_IMAGE_URL}/${b.process_image}`,
              remarks: b.remarks,
              pkBagManageKey: b.pk_bag_manage_key
            };
          });

          if (formatted.length > 0) {
            // choose appropriate bag index — for single-bag view, first one is fine
            setPkBagManageKey(formatted[0].pkBagManageKey || pkBagManageKey);
          }
          setBags(formatted);
        }

      })
      .catch(err => console.error(err));
  }, [batchKey]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/getBagHistory/bag/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fk_batch_key: batchKey, fk_bag_key: bagKey }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success === 1 && Array.isArray(data.bags?.data)) {
          let history = data.bags.data;

          // Sort history by created_on (oldest → newest)
          history = history.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));

          const formatted = history.map((b, index) => {
            const nextProcess = history[index + 1];

            // Completed Date = start date of next process
            const completedDate = nextProcess ? nextProcess.process_date : "-";

            let status = "Pending";
            if (!nextProcess) {
              status = "In Progress";
            } else {
              status = "Completed";
            }

            let color = "secondary";
            if (status === "Completed") color = "success";
            else if (status === "In Progress") color = "warning";

            return {
              id: b.fk_process_seq_key,
              processName: b.process_name,
              startDate: b.process_date,
              completedDate,
              remarks: b.remarks,
              status,
              color,
              processImage: `${process.env.REACT_APP_IMAGE_URL}/${b.process_image}`,
            };
          });

          setProcessHistory(formatted);
        }
      })
      .catch(err => console.error(err));
  }, [batchKey, bagKey]);



  function getIndianDate() {
    const date = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kolkata"
    });

    return new Date(date).toISOString().slice(0, 10);
  }
  const adminKey = sessionStorage.getItem("pk_admin_key");



  const handleStageChange = async () => {
    if (!selectedBag || !newStage) return;

    const payload = {
      fk_batch_key: batchKey,
      fk_bag_key: selectedBag.bagKey,
      fk_process_key: newStage.pk_process_key,
      fk_process_seq_key: newStage.pk_sequence_key,
      process_name: newStage.process_name,
      process_date: getIndianDate(),
      status: '1',
      created_by: adminKey,
      fk_farm_key: selectedFarmKey
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/changeProcess/bag/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const result = await res.json();

      if (result?.message?.success === true) {
        toast.success(result?.message?.message || "Stage updated successfully!");
        setModalOpen(false);
        fetchProcesses();
        fetchSavedSequence();
        loadBagDetails();
        loadBagHistoryDetails();
      } else {
        toast.error(result?.message?.message || "Failed to update stage");
      }
    } catch (err) {
      console.log(err);
      toast.error("Error updating stage");
    }
  };

  const saveRemarks = async (bagKey, remarkText, pkManageKey = null) => {
    try {
      const payload = {
        fk_bag_key: bagKey,
        pk_bag_manage_key: pkManageKey || pkBagManageKey, // use passed value, else state
        remarks: remarkText,
        modified_by: adminKey,
        fk_farm_key: selectedFarmKey,
      };

      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/saveBagRemarks/bag/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      const isSuccess = result?.message?.success === true;

      if (isSuccess) {
        // refresh UI
        fetchProcesses();
        fetchSavedSequence();
        loadBagDetails();
        loadBagHistoryDetails();
      }

      return isSuccess;
    } catch (err) {
      console.error("Remarks save error", err);
      return false;
    }
  };

  function getNextProcess(bag) {

    const current = sequenceList.find(s => s.pk_sequence_key === bag.processSeqKey);
    if (!current) return null;

    const nextPos = Number(current.process_position) + 1;

    const nextSeq = sequenceList.find(s => Number(s.process_position) === nextPos);
    if (!nextSeq) return null;

    return processList.find(p => p.pk_process_key === nextSeq.fk_process_key);
  }



  // Modal state
  const [modalOpen, setModalOpen] = useState(false)
  const [remarksModalOpen, setRemarksModalOpen] = useState(false)
  const [selectedBag, setSelectedBag] = useState(null)
  const [newStage, setNewStage] = useState("")
  const [remarksText, setRemarksText] = useState("")


  const getStatusColor = status => {
    return status === "Completed" ? "success" : "warning"
  }

  // Check if bag is overdue
  const isOverdue = endDate => {
    const today = new Date("2025-11-11")
    const due = new Date(endDate)
    return due < today
  }

  // Get alert color and message
  const getAlertInfo = bag => {
    if (bag.status === "Completed") {
      return {
        color: "info",
        icon: "mdi-check-circle",
        message: "This bag has completed all stages",
      }
    } else if (isOverdue(bag.endDate)) {
      return {
        color: "danger",
        icon: "mdi-alert-circle",
        message: "This bag is overdue! Please check immediately",
      }
    } else {
      return {
        color: "success",
        icon: "mdi-clock-outline",
        message: "This bag is on track and progressing well",
      }
    }
  }

  // State to track which dropdown is open - using bag id as key
  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleDropdown = bagId => {
    setOpenDropdown(openDropdown === bagId ? null : bagId)
  }

  // Open change stage modal
  const openChangeStageModal = bag => {
    setSelectedBag(bag)
    setNewStage(bag.currentStage)
    setModalOpen(true)
    setOpenDropdown(null)
  }

  const openRemarksModal = bag => {
    setSelectedBag(bag)
    setRemarksText(bag.remarks || "")
    setRemarksModalOpen(true)
    setOpenDropdown(null)
  }



  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "Completed":
        return "success"
      case "In Progress":
        return "warning"
      case "Pending":
        return "secondary"
      default:
        return "secondary"
    }


  }
  const startNextProcess = async (bag) => {

    const nextProc = getNextProcess(bag);
    if (!nextProc) {
      toast.info("No next process. Already completed.");
      return;
    }

    const currentSeq = sequenceList.find(s => s.pk_sequence_key === bag.processSeqKey);
    if (!currentSeq) {
      toast.error("Current sequence entry not found. Cannot determine next sequence.");
      return;
    }

    const nextPosition = Number(currentSeq.process_position) + 1;
    const nextSeq = sequenceList.find(s => Number(s.process_position) === nextPosition && s.fk_process_key === nextProc.pk_process_key);

    if (!nextSeq) {
      toast.error("Next sequence entry not found. Cannot start next process.");
      return;
    }

    if (remarksText?.trim()) {
      const saved = await saveRemarks(bag.bagKey, remarksText, bag.pkBagManageKey || pkBagManageKey);
      if (!saved) {
        toast.error("Failed to save remarks");
        return;
      }
    }

    const payload = {
      fk_batch_key: batchKey,
      fk_bag_key: bag.bagKey,
      fk_process_key: nextProc.pk_process_key,
      fk_process_seq_key: nextSeq.pk_sequence_key,
      process_name: nextProc.process_name,
      process_date: getIndianDate(),
      status: '1',
      created_by: adminKey,
      fk_farm_key: selectedFarmKey
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/changeProcess/bag/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await res.json();

      if (result?.message?.success === true) {
        const newPk = result?.message?.data?.pk_bag_manage_key || result?.message?.data?.pk_bag_manage || result?.message?.pk_bag_manage_key;

        if (newPk) {
          setPkBagManageKey(newPk);
          // also update the selected bag object so UI uses latest pk
          setSelectedBag(prev => prev ? { ...prev, pkBagManageKey: newPk } : prev);
        }
        toast.success(result?.message?.message || "Stage updated!");
        fetchProcesses();
        fetchSavedSequence();
        loadBagDetails();
        loadBagHistoryDetails();
      } else {
        toast.error(result?.message?.message || "Failed to update stage");
      }
    } catch (err) {
      console.error("startNextProcess error:", err);
      toast.error("Error updating stage");
    }
  };


  const loadBagDetails = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/getBagDetails/batch`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fk_batch_key: batchKey, fk_bag_key: bagKey }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success === 1 && Array.isArray(data.bags?.data)) {
          const formatted = data.bags.data.map(b => {
            const progress = calculateProgress(b.process_created_on, b.process_duration);
            const dueDate = calculateDueDate(b.process_date, b.process_duration);
            return {
              id: b.bag_num,
              fk_batch_key: b.fk_batch_key,
              bagKey: b.bag_key,
              batchId: b.batch_num,
              processKey: b.fk_process_key,
              processSeqKey: b.fk_process_seq_key,
              currentStage: b.current_stage,
              startDateDate: b.process_date,
              startDate: b.process_created_on,
              processDuration: b.process_duration,
              progress,
              dueDate: dueDate,
              status: "In-Progress",
              qr_image: b.qr_image,
              processImage: `${process.env.REACT_APP_IMAGE_URL}/${b.process_image}`,
              remarks: b.remarks,
              pkBagManageKey: b.pk_bag_manage_key
            };
          });
          if (formatted.length > 0) {
            // choose appropriate bag index — for single-bag view, first one is fine
            setPkBagManageKey(formatted[0].pkBagManageKey || pkBagManageKey);
          }
          setBags(formatted);
        }
      })
      .catch(err => console.error(err));
  };

  const loadBagHistoryDetails = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/getBagHistory/bag/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fk_batch_key: batchKey, fk_bag_key: bagKey }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success === 1 && Array.isArray(data.bags?.data)) {
          let history = data.bags.data;

          // Sort history by created_on (oldest → newest)
          history = history.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));

          const formatted = history.map((b, index) => {
            const nextProcess = history[index + 1];

            // Completed Date = start date of next process
            const completedDate = nextProcess ? nextProcess.process_date : "-";

            let status = "Pending";
            if (!nextProcess) {
              status = "In Progress";
            } else {
              status = "Completed";
            }

            let color = "secondary";
            if (status === "Completed") color = "success";
            else if (status === "In Progress") color = "warning";

            return {
              id: b.fk_process_seq_key,
              processName: b.process_name,
              startDate: b.process_date,
              completedDate,
              remarks: b.remarks,
              status,
              color,
              processImage: `${process.env.REACT_APP_IMAGE_URL}/${b.process_image}`,
            };
          });

          setProcessHistory(formatted);
        }
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    if (!batchKey) return;
    loadBagDetails();
    loadBagHistoryDetails();
  }, [batchKey]);


  const handleSaveRemarks = async () => {
    if (!selectedBag || !remarksText.trim()) return;

    const saved = await saveRemarks(selectedBag.bagKey, remarksText, selectedBag.pkBagManageKey);

    if (saved) {
      toast.success("Remarks saved!");

      loadBagDetails();
      fetchProcesses();
      fetchSavedSequence();
      loadBagHistoryDetails();

      setRemarksModalOpen(false);
    } else {
      toast.error("Failed to save remarks");
    }
  };



  useEffect(() => {
    if (selectedFarmKey) {
      fetchSavedSequence(selectedFarmKey);
      fetchProcesses(selectedFarmKey);
    }
  }, [selectedFarmKey]);


  return (
    <React.Fragment>
      {/* Header Section */}
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="d-flex align-items-start">
          <Button
            color="link"
            className="p-0 me-2"
            onClick={() => window.history.back()}
          >
            <i className="mdi mdi-arrow-left fs-4"></i>
          </Button>

          <Breadcrumb />
        </div>

        {/* <Button
          type="button"
          color="primary"
          className="waves-effect waves-light"
        >
          <i className="mdi mdi-plus me-1"></i>
          Add New Bag
        </Button> */}
      </div>

      {/* Bags Grid */}
      <Row>
        {bags.map(bag => (
          <Col xs={12} lg={8} key={bag.id} className="mb-4">
            <Card className="border shadow-sm h-100">
              {/* Header */}
              <CardHeader className="bg-light border-bottom">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div>
                    <h5 className="mb-1 fw-semibold">Bag ID: {bag.id}</h5>
                    <p className="mb-0 text-muted small">
                      <i className="mdi mdi-package-variant me-1"></i>
                      Batch: {bag.batchId}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Badge
                      color={getStatusColor(bag.status)}
                      className="px-2 py-1"
                    >
                      {bag.status}
                    </Badge>
                    <Dropdown
                      isOpen={openDropdown === bag.id}
                      toggle={() => toggleDropdown(bag.id)}
                    >
                      <DropdownToggle
                        tag="button"
                        className="btn btn-link text-muted p-0 border-0 shadow-none"
                      >
                        <i className="mdi mdi-dots-vertical fs-5"></i>
                      </DropdownToggle>
                      <DropdownMenu end>
                        <Link to="/bag-details">
                          {/* <DropdownItem>
                      <i className="mdi mdi-eye-outline me-2"></i>
                      View Details
                    </DropdownItem> */}
                        </Link>
                        <DropdownItem onClick={() => openChangeStageModal(bag)}>
                          <i className="mdi mdi-swap-horizontal me-2"></i>
                          Change Stage
                        </DropdownItem>
                        <DropdownItem onClick={() => openRemarksModal(bag)}>
                          <i className="mdi mdi-note-text-outline me-2"></i>
                          Add/Edit Remarks
                        </DropdownItem>
                        <DropdownItem divider />
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </CardHeader>

              {/* Body */}
              <CardBody className="p-3">
                {/* Alert Message */}
                <div className={`alert alert-${getAlertInfo(bag).color} mb-3`}>
                  <i className={`mdi ${getAlertInfo(bag).icon} me-2`}></i>
                  {getAlertInfo(bag).message}
                </div>

                {/* Stage Image and Info - Responsive Layout */}
                <div className="d-flex flex-column flex-md-row gap-3 mb-3 justify-content-between">
                  {/* Stage Image and Details */}
                  <div className="d-flex flex-column flex-sm-row gap-3">
                    {/* Stage Image */}
                    <div className="flex-shrink-0  text-sm-start">
                      <img
                        src={bag.processImage}
                        alt={bag.currentStage}
                        className="rounded"
                        style={{ width: "80px" }}
                      />
                    </div>
                    {/* Stage Details - Responsive Grid */}
                    <div className="d-flex flex-wrap gap-3">
                      <div className="">
                        <span className="text-muted small d-block">
                          Current Process
                        </span>
                        <span className="fw-semibold text-primary">
                          {bag.currentStage}
                        </span>
                      </div>
                      <div className="">
                        <span className="text-muted small d-block">
                          Start Date
                        </span>
                        <span className="fw-medium">{bag.startDateDate}</span>
                      </div>
                      <div className="">
                        <span className="text-muted small d-block">
                          Due Date
                        </span>
                        <span className="fw-medium">{bag.dueDate}</span>
                      </div>
                    </div>
                  </div>

                  {/* QR Code - Centered on mobile */}
                  <div className=" text-md-end ">
                    <img
                      src={`${process.env.REACT_APP_QRIMAGE_URL}/${bag.qr_image}`}
                      alt="QR Code"
                      className="qr-code-img"
                      style={{
                        border: "1px solid #9b9b9b",
                        borderRadius: "4px"
                      }}
                    />
                  </div>
                </div>

                {/* Remarks Section */}
                <div className="mb-3 p-2 bg-light rounded border">
                  <div className="d-flex align-items-start justify-content-between">
                    <div className="flex-grow-1">
                      <span className="text-muted small d-block mb-1">
                        <i className="mdi mdi-note-text-outline me-1"></i> Remarks
                      </span>
                      <p className="mb-0 small">
                        {bag.remarks ? bag.remarks : "No remarks added yet"}
                      </p>
                    </div>
                    <Button
                      color="link"
                      size="sm"
                      className="p-0 text-primary"
                      onClick={() => openRemarksModal(bag)}
                    >
                      <i className="mdi mdi-pencil"></i>
                    </Button>
                  </div>
                </div>

                {/* Progress Section - Responsive */}
                {/* <div className="border-top pt-3">
                  <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-3">

                    <div className="w-100 w-sm-50">

                    </div>
                    <div className="d-flex flex-column align-items-start align-items-sm-end w-100 w-sm-auto">
                      <h6 className="mb-2">
                        Next Process: <b>{getNextProcess(bag)?.process_name || "-"}</b>
                      </h6>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => startNextProcess(bag)}
                        className="d-flex align-items-center waves-effect waves-light w-100 w-sm-auto justify-content-center"
                      >
                        <i className="mdi mdi-arrow-right-circle me-1"></i> Start
                      </Button>
                    </div>
                  </div>
                </div> */}

                {/* Harvest Count Section - Left side of Next Process */}
                <div className="border-top pt-3">
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3">

                    {/* Harvest Section (LEFT) */}
                    <div className="d-flex flex-column">
                      <h6 className="mb-2">Add Harvest Count (in grams)</h6>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => openHarvestModal(bag)}
                        className="d-flex align-items-center waves-effect waves-light w-100 w-sm-auto justify-content-center"
                      >
                        <i className="mdi mdi-arrow-right-circle me-1"></i> Add
                      </Button>

                    </div>

                    {/* Next Process Section (RIGHT) */}
                    <div className="d-flex flex-column align-items-start align-items-sm-end w-100 w-sm-auto">
                      <h6 className="mb-2">
                        Next Process: <b>{getNextProcess(bag)?.process_name || "-"}</b>
                      </h6>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => startNextProcess(bag)}
                        className="d-flex align-items-center waves-effect waves-light w-100 w-sm-auto justify-content-center"
                      >
                        <i className="mdi mdi-arrow-right-circle me-1"></i>
                        Start
                      </Button>
                    </div>

                  </div>
                </div>

              </CardBody>
            </Card>
          </Col>
        ))}

        {/* Process History Card */}
        <Col xs={12} lg={4} className="mb-4">
          <Card className="border shadow-sm h-100">
            <CardHeader className="bg-light border-bottom">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0 fw-semibold">
                  <i className="mdi mdi-timeline-clock me-2"></i>
                  Process History
                </h5>
                <Badge color="primary" className="px-2 py-1">
                  {processHistory.filter(p => p.status === "Completed").length}/
                  {processHistory.length}
                </Badge>
              </div>
            </CardHeader>

            <CardBody className="p-0">
              <div className="timeline-container">
                {processHistory.map((process, index) => (
                  <div
                    key={process.id}
                    className={`timeline-item ${index === processHistory.length - 1 ? 'last' : ''}`}
                  >
                    {/* Timeline Line */}
                    <div className="timeline-line">
                      <div className={`timeline-icon bg-${process.color}`}>
                        <i className={`mdi ${process.icon} text-white`}></i>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="timeline-content">
                      <div className="d-flex align-items-start justify-content-between mb-2 flex-wrap gap-2">
                        <div>
                          <h6 className="mb-1 fw-semibold">{process.processName}</h6>
                          <Badge
                            color={getStatusBadgeColor(process.status)}
                            className="px-2 py-1"
                            style={{ fontSize: "10px" }}
                          >
                            {process.status}
                          </Badge>
                        </div>
                      </div>

                      {/* Dates - Responsive */}
                      <div className="mb-2">
                        <div className="d-flex align-items-center mb-1 flex-wrap">
                          <i className="mdi mdi-calendar-start text-muted me-2" style={{ fontSize: "14px" }}></i>
                          <span className="text-muted small">
                            Start: <span className="text-dark fw-medium">{process.startDate}</span>
                          </span>
                        </div>
                        <div className="d-flex align-items-center flex-wrap">
                          <i className="mdi mdi-calendar-check text-muted me-2" style={{ fontSize: "14px" }}></i>
                          <span className="text-muted small">
                            Completed: <span className={`fw-medium ${process.completedDate === "-" ? "text-muted" : "text-dark"}`}>
                              {process.completedDate}
                            </span>
                          </span>
                        </div>
                      </div>

                      {/* Remarks */}
                      <div className="remarks-box p-2 bg-light rounded border">
                        <div className="d-flex align-items-start">
                          <i className="mdi mdi-note-text-outline text-muted me-2 mt-1" style={{ fontSize: "14px" }}></i>
                          <p className="mb-0 small text-muted">{process.remarks || 'No remarks available'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>

          <style jsx>{`
      .timeline-container {
        padding: 20px 15px;
        position: relative;
      }

      .timeline-item {
        display: flex;
        position: relative;
        padding-bottom: 25px;
      }

      .timeline-item.last {
        padding-bottom: 0;
      }

      .timeline-line {
        position: relative;
        width: 40px;
        flex-shrink: 0;
      }

      .timeline-line::before {
        content: '';
        position: absolute;
        left: 15px;
        top: 35px;
        bottom: -25px;
        width: 2px;
        background: #e9ecef;
      }

      .timeline-item.last .timeline-line::before {
        display: none;
      }

      .timeline-icon {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }

      .timeline-icon i {
        font-size: 16px;
      }

      .timeline-content {
        flex: 1;
        padding-left: 15px;
        padding-top: 2px;
        min-width: 0; /* Prevents overflow */
      }

      .remarks-box {
        margin-top: 8px;
        border-left: 3px solid #dee2e6 !important;
        word-break: break-word;
      }

      .bg-success {
        background-color: #34c38f !important;
      }

      .bg-warning {
        background-color: #f1b44c !important;
      }

      .bg-secondary {
        background-color: #74788d !important;
      }

      .qr-code-img {
        width: 80px;
        height: 80px;
      }

      /* Responsive Styles */
      @media (max-width: 575.98px) {
        .timeline-container {
          padding: 15px 10px;
        }

        .timeline-line {
          width: 35px;
        }

        .timeline-icon {
          width: 28px;
          height: 28px;
        }

        .timeline-icon i {
          font-size: 14px;
        }

        .timeline-content {
          padding-left: 10px;
        }

        .qr-code-img {
          width: 70px;
          height: 70px;
        }
      }

      @media (max-width: 767.98px) {
        .w-sm-50 {
          width: 100% !important;
        }
        
        .w-sm-auto {
          width: 100% !important;
        }
      }

      @media (min-width: 576px) {
        .w-sm-50 {
          width: 50% !important;
        }
        
        .w-sm-auto {
          width: auto !important;
        }
      }
    `}</style>
        </Col>
      </Row>

      {/* Change Stage Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Change Stage - {selectedBag?.id}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label className="fw-medium">Current Process</Label>
            <Input
              type="text"
              value={selectedBag?.currentStage || ""}
              disabled
              className="bg-light"
            />
          </div>
          <div className="mb-3">
            <Label className="fw-medium">
              New Stage <span className="text-danger">*</span>
            </Label>
            <Input
              type="select"
              value={newStage?.pk_process_key || ""}
              onChange={e => {
                const process = processList.find(p => p.pk_process_key === e.target.value);

                const matchingSeq = sequenceList.find(
                  s => s.fk_process_key === process.pk_process_key
                );

                setNewStage({
                  ...process,
                  pk_sequence_key: matchingSeq ? matchingSeq.pk_sequence_key : null,
                  process_position: matchingSeq ? matchingSeq.process_position : null
                });
              }}
            >
              <option value="">Select Process</option>

              {processList.map(proc => (
                <option key={proc.pk_process_key} value={proc.pk_process_key}>
                  {proc.process_name} (Process Position: {proc.process_position})
                </option>
              ))}
            </Input>
          </div>
          {/* <div className="alert alert-info mb-0">
            <i className="mdi mdi-information-outline me-2"></i>
            Progress will be automatically updated based on the selected stage.
          </div> */}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleStageChange}>
            Update Stage
          </Button>
        </ModalFooter>
      </Modal>

      {/* Remarks Modal */}
      <Modal
        isOpen={remarksModalOpen}
        toggle={() => setRemarksModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setRemarksModalOpen(false)}>
          {selectedBag?.remarks ? "Edit Remarks" : "Add Remarks"} -{" "}
          {selectedBag?.id}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label className="fw-medium">
              Remarks <span className="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              rows="5"
              placeholder="Enter remarks about the bag condition, growth, contamination, or any observations..."
              value={remarksText}
              onChange={e => setRemarksText(e.target.value)}
            />
          </div>
          <div className="alert alert-info mb-0">
            <i className="mdi mdi-information-outline me-2"></i>
            Add detailed observations to track the bag's progress and condition.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setRemarksModalOpen(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleSaveRemarks}
            disabled={!remarksText.trim()}
          >
            Save Remarks
          </Button>
        </ModalFooter>
      </Modal>


      {/* Harvest Count Modal */}
      <Modal
        isOpen={harvestModalOpen}
        toggle={() => setHarvestModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setHarvestModalOpen(false)}>
          Add Harvest Count - {selectedHarvestBag?.id}
        </ModalHeader>

        <ModalBody>
          {/* Date */}
          <div className="mb-3">
            <Label className="fw-medium">
              Harvest Date <span className="text-danger">*</span>
            </Label>
            <Input
              type="date"
              value={harvestDate}
              onChange={(e) => setHarvestDate(e.target.value)}
            />
          </div>

          {/* Count */}
          <div className="mb-3">
            <Label className="fw-medium">
              Harvest Count (in grams) <span className="text-danger">*</span>
            </Label>
            <Input
              type="number"
              placeholder="Enter count in grams"
              value={harvestCount}
              onChange={(e) => setHarvestCount(e.target.value)}
            />
          </div>

          <div className="alert alert-info mb-0">
            <i className="mdi mdi-information-outline me-2"></i>
            Please enter the final harvested weight for this bag.
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={() => setHarvestModalOpen(false)}>
            Cancel
          </Button>

          <Button
            color="primary"
            onClick={handleSaveHarvest}
            disabled={!harvestDate || !harvestCount}
          >
            Save Harvest
          </Button>
        </ModalFooter>
      </Modal>


      <style jsx>{`
        .hover-text-primary:hover {
          color: #556ee6 !important;
        }
        .hover-text-danger:hover {
          color: #f46a6a !important;
        }
      `}</style>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(BagDetails)
